import React from 'react';
import Button from '@mui/material/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { apiUrl } from '../apiBase';

export default function WhatsAppLoginButton({ text = 'WhatsApp ile giriş (Mesaj gönder)', schoolId, disabled = false }) {
  const [link, setLink] = React.useState(null);

  React.useEffect(() => {
    setLink(null);
    if (!schoolId) return undefined;
    let mounted = true;
    (async () => {
      try {
        const params = new URLSearchParams({ school_id: schoolId });
        const url = apiUrl(`/auth/wa_link?${params.toString()}`);
        const res = await fetch(url);
        if (res.ok) {
          const data = await res.json();
          if (data?.wa_deeplink && mounted) setLink({ schoolId, href: data.wa_deeplink });
        }
      } catch (_) { /* keep the button disabled until the selected school's link is available */ }
    })();
    return () => { mounted = false; };
  }, [schoolId]);
  return (
    <Button
      fullWidth
      component="a"
      href={link?.schoolId === schoolId ? link.href : undefined}
      disabled={disabled || !schoolId || link?.schoolId !== schoolId}
      variant="contained"
      color="primary"
      startIcon={<WhatsAppIcon />}
      sx={{ textTransform: 'none', fontWeight: 600 }}
    >
      {text}
    </Button>
  );
}
